import { JobStatus } from '@core/generated/gql-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { useJobUtils } from './useJobUtils';

interface JobHeaderProps {
  title: string;
  status?: JobStatus;
  clientName?: string;
  clientId?: string;
  clientLogoUrl?: string;
}

const JobHeader: React.FC<JobHeaderProps> = ({
  title,
  status,
  clientName,
  clientId,
  clientLogoUrl,
}) => {
  const { getStatusBadgeClass } = useJobUtils();

  return (
    <div className="mb-6 flex items-center gap-4">
      {clientLogoUrl && (
        <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-gray-100">
          <img
            src={clientLogoUrl}
            alt={clientName}
            className="h-14 w-14 object-contain"
          />
        </div>
      )}
      <div className="flex-1">
        <div className="flex items-center gap-3">
          <h1
            style={{ fontSize: '2.5rem' }}
            className="text-xl font-bold text-gray-800"
          >
            {title}
          </h1>
          {status && (
            <span
              className={`rounded-sm px-2 py-1 text-xs font-semibold ${getStatusBadgeClass(status)}`}
            >
              {status}
            </span>
          )}
        </div>
        {clientName && (
          <div className="mt-1 text-sm text-gray-600">
            {clientId ? (
              <Link
                to={`/clients/${clientId}`}
                className="text-gray-600 hover:text-gray-900 hover:underline"
              >
                {clientName}
              </Link>
            ) : (
              clientName
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default JobHeader;
